<template>
    <v-text-field
        v-mask="TimeMask"
        placeholder="00:00-23:59"
        v-model="time"
        :label="title"
        :clearable="clearable"
        :readonly="readonly"
        hide-details="auto"
        class="shrink"
        dense
        outlined
    ></v-text-field>
</template>

<script>
export default {
    props: {
        value: String,
        label: String,
        clearable: Boolean,
        readonly: Boolean,
    },
    data() {
        return {
            time: null,
        };
    },
    mounted() {
        this.time = this.value;
    },
    computed: {
        title() {
            return this.label || this.$t('Time');
        }
    },
    watch: {
        value(val) {
            if (this.time != val) {
                this.time = val;
            }
        },
        time(val, oldVal) {
            if (val === oldVal) {
                return;
            }
            this.$emit('input', val);
        },
    },
    methods: {
        TimeMask(value) {
            const hours = [
                /[0-2]/,
                value.charAt(0) === '2' ? /[0-3]/ : /[0-9]/,
            ];
            const minutes = [/[0-5]/, /[0-9]/];
            return value.length > 2 ? [...hours, ':', ...minutes] : hours;
        },
    },
};
</script>

<style>
</style>